import JsBarcode from 'jsbarcode';
const PAPERS = { letter: [215.9, 279.4], a4: [210, 297] };

function planEtiquetas(settings) {
  const { paper = 'letter', width = 30, height = 20, marginX = 8, marginY = 8, gapX = 2, gapY = 2, copies = 50 } = settings;
  const size = PAPERS[paper];
  const values = { width, height, marginX, marginY, gapX, gapY, copies };
  Object.keys(values).forEach(key => { values[key] = Number(values[key]); });
  if (!size || Object.values(values).some(value => !Number.isFinite(value))) throw new Error('Completa las medidas y el formato de papel.');
  const v = values;
  if (v.width < 20 || v.width > 150 || v.height < 15 || v.height > 100) throw new Error('Usa etiquetas de 20 a 150 mm de ancho y 15 a 100 mm de alto.');
  if ([v.marginX, v.marginY, v.gapX, v.gapY].some(value => value < 0 || value > 50)) throw new Error('Los márgenes y separaciones deben estar entre 0 y 50 mm.');
  if (!Number.isSafeInteger(v.copies) || v.copies < 1 || v.copies > 5000) throw new Error('La cantidad de etiquetas debe ser un entero entre 1 y 5000.');
  const columns = Math.floor((size[0] - 2 * v.marginX + v.gapX + 1e-7) / (v.width + v.gapX));
  const rows = Math.floor((size[1] - 2 * v.marginY + v.gapY + 1e-7) / (v.height + v.gapY));
  if (columns < 1 || rows < 1) throw new Error('La etiqueta no cabe en la hoja con esos márgenes.');
  const perPage = columns * rows;
  return { ...v, paper, pageWidth: size[0], pageHeight: size[1], columns, rows, perPage, pages: Math.ceil(v.copies / perPage) };
}
function barcodeData(code, width, moduleWidth = 0.25) {
  const text = String(code || '').trim();
  if (!/^[\x20-\x7e]{1,80}$/.test(text)) throw new Error('Code 128 requiere un código de 1 a 80 caracteres sin tildes. Puedes generar un código numérico para unidad.');
  const module = Number(moduleWidth);
  if (![0.25, 0.33, 0.4].includes(module)) throw new Error('Selecciona un ancho de barra válido.');
  const encoded = {};
  JsBarcode(encoded, text, { format: 'CODE128', displayValue: false, margin: 0 });
  const bits = encoded.encodings.map(part => part.data).join('');
  const fullWidth = (bits.length + 20) * module;
  if (fullWidth > Number(width) - 2 + 1e-7) throw new Error(`Este código necesita una etiqueta de al menos ${Math.ceil(fullWidth + 2)} mm de ancho. Aumenta el ancho o genera el código corto para unidad.`);
  return { text, bits, moduleWidth: module, fullWidth, quietZone: 10 * module };
}
function crearPdfEtiquetas({ producto, codigo, settings, guides = true, showName = true }) {
  const plan = planEtiquetas(settings);
  const barcode = barcodeData(codigo, plan.width, settings.moduleWidth ?? 0.25);
  const { jsPDF } = require('jspdf');
  const doc = new jsPDF({ unit: 'mm', format: [plan.pageWidth, plan.pageHeight], orientation: 'portrait', compress: true });
  doc.setProperties({ title: `Etiquetas - ${producto.descripcion || producto.id}`, subject: `${plan.copies} etiquetas Code 128. Imprimir al 100%.` });
  for (let i = 0; i < plan.copies; i++) {
    if (i && i % plan.perPage === 0) doc.addPage([plan.pageWidth, plan.pageHeight], 'portrait');
    const cell = i % plan.perPage;
    const x = plan.marginX + (cell % plan.columns) * (plan.width + plan.gapX);
    const y = plan.marginY + Math.floor(cell / plan.columns) * (plan.height + plan.gapY);
    if (guides) {
      doc.setDrawColor(190); doc.setLineWidth(0.1); doc.setLineDashPattern([0.5, 0.5], 0);
      doc.rect(x, y, plan.width, plan.height); doc.setLineDashPattern([], 0);
    }
    doc.setTextColor(0); doc.setFillColor(0); doc.setFont('helvetica', 'normal');
    if (showName) {
      doc.setFontSize(6);
      const lines = doc.splitTextToSize(String(producto.descripcion || ''), plan.width - 2);
      doc.text(lines[0] || '', x + plan.width / 2, y + 2.5, { align: 'center' });
    }
    const barsY = y + (showName ? 3.3 : 1);
    const barsH = plan.height - (showName ? 6.7 : 4.5);
    const barsX = x + (plan.width - barcode.fullWidth) / 2 + barcode.quietZone;
    for (let b = 0; b < barcode.bits.length;) {
      const start = b; const bit = barcode.bits[b];
      while (barcode.bits[b] === bit) b++;
      if (bit === '1') doc.rect(barsX + start * barcode.moduleWidth, barsY, (b - start) * barcode.moduleWidth, barsH, 'F');
    }
    doc.setFontSize(6);
    doc.text(barcode.text, x + plan.width / 2, y + plan.height - 1, { align: 'center' });
  }
  return { doc, plan };
}
export { planEtiquetas, barcodeData, crearPdfEtiquetas };
